/**
 * Chrome that sits outside a screen's content column.
 *
 * Kept in a dependency-free module so layout math can be unit-tested without
 * pulling in the components that render it.
 */

/** Width of the persistent desktop-web nav rail (`DesktopSidebar`). */
export const DESKTOP_SIDEBAR_WIDTH = 180;

/** Sidebar plus its 1px right border — what a screen loses on desktop web. */
export const DESKTOP_SIDEBAR_TOTAL_WIDTH = DESKTOP_SIDEBAR_WIDTH + 1;
